// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__qQZt_","productName":"Table_productName__3J3b0"};